export const SHIPPING_TYPES_RESET_STATE = 'SHIPPING_TYPES_RESET_STATE';
export const SHIPPING_TYPES_CURRENT_ITEM = 'SHIPPING_TYPES_CURRENT_ITEM';

export const SHIPPING_TYPES_REQUEST_LOADING = 'SHIPPING_TYPES_REQUEST_LOADING';
export const SHIPPING_TYPES_REQUEST_SUCCESS = 'SHIPPING_TYPES_REQUEST_SUCCESS';
export const SHIPPING_TYPES_REQUEST_FAILED = 'SHIPPING_TYPES_REQUEST_FAILED';

export const SHIPPING_TYPES_CURRENT_ACTION = 'SHIPPING_TYPES_CURRENT_ACTION';
export const SHIPPING_TYPES_RESET_ACTION = 'SHIPPING_TYPES_RESET_ACTION';